module.exports = __webpack_public_path__ + "static/main-d1f153e6bf5bf29c6ae9e71d96e82919.jpg";